import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { Hotel } from "lucide-react";

const STATUS = { confirme: "Confirmé", en_attente: "En attente", annule: "Annulé", termine: "Terminé" };
const COLOR = { confirme: "#059669", en_attente: "#D97706", annule: "#868E96", termine: "#002FA7" };

export default function ChefReservations() {
  return (
    <SectorCRUDTable
      endpoint="/chef/secteur/reservations"
      eyebrow="Camping / Hôtellerie · Réservations"
      title="Réservations"
      sub="Pilotez vos arrivées, départs, paiements clients."
      testidPrefix="reservation"
      allowEdit
      defaultRow={() => ({ client_nom: "", client_telephone: "", client_email: "", unite: "", date_arrivee: new Date().toISOString().slice(0, 10), date_depart: new Date().toISOString().slice(0, 10), nb_personnes: 1, prix_total: 0, acompte: 0, status: "confirme", notes: "" })}
      columns={[
        { key: "unite", label: "Unité", width: "140px", render: (v) => <span className="font-mono font-bold">{v}</span> },
        { key: "client_nom", label: "Client" },
        { key: "date_arrivee", label: "Arrivée", width: "110px", render: (v) => v ? new Date(v).toLocaleDateString("fr-FR") : "—" },
        { key: "date_depart", label: "Départ", width: "110px", render: (v) => v ? new Date(v).toLocaleDateString("fr-FR") : "—" },
        { key: "nb_personnes", label: "Pers.", width: "60px" },
        { key: "prix_total", label: "Prix", width: "100px", render: (v) => <span className="font-mono">{(v || 0).toFixed(2)} €</span> },
        { key: "status", label: "Statut", width: "120px", render: (v) => <span className="text-[9px] uppercase font-bold px-2 py-0.5" style={{ color: COLOR[v], background: `${COLOR[v]}15` }}>{STATUS[v] || v}</span> },
      ]}
      fields={[
        { key: "client_nom", label: "Client", span: 6, required: true },
        { key: "client_telephone", label: "Téléphone", span: 6 },
        { key: "client_email", label: "Email", span: 8 },
        { key: "nb_personnes", label: "Personnes", type: "number", span: 4 },
        { key: "unite", label: "Unité (chalet, suite…)", span: 6, required: true },
        { key: "status", label: "Statut", type: "select", span: 6, options: Object.entries(STATUS).map(([v, l]) => ({ value: v, label: l })) },
        { key: "date_arrivee", label: "Date arrivée", type: "date", span: 6, required: true },
        { key: "date_depart", label: "Date départ", type: "date", span: 6, required: true },
        { key: "prix_total", label: "Prix total (€)", type: "number", step: "0.01", span: 6 },
        { key: "acompte", label: "Acompte (€)", type: "number", step: "0.01", span: 6 },
        { key: "notes", label: "Notes", type: "textarea", span: 12 },
      ]}
      emptyIcon={Hotel}
      emptyText="Aucune réservation."
    />
  );
}
